import * as constants from './constants';

export const participantsTableHead = {
    [constants.FIELD_ID]: 'ID',
    [constants.FIELD_LASTNAME]: 'Фамилия',
    [constants.FIELD_NAME]: 'Имя',
    [constants.FIELD_PATRONYMIC]: 'Отчество',
    [constants.FIELD_COMPANY]: 'Организация',
    [constants.FIELD_ROLES]: 'Дополнительный признак',
    [constants.FIELD_TAGS]: 'Теги',
};

export const initialRoleModel = {
    [constants.TITLE_RU]: '',
    [constants.TITLE_EN]: '',
    [constants.GROUP_TITLE_RU]: '',
    [constants.GROUP_TITLE_EN]: '',
};

export const participantFormFields = {
    [constants.FIELD_LASTNAME]: 'Фамилия',
    [constants.FIELD_NAME]: 'Имя',
    [constants.FIELD_PATRONYMIC]: 'Отчество',
    [constants.FIELD_COMPANY]: 'Организация',
    [constants.FIELD_REGALIA]: 'Регалия',
    [constants.FIELD_BIOGRAPHY]: 'Описание / биография',
    [constants.FIELD_TELEGRAM]: 'Телеграм',
    [constants.FIELD_VK]: 'ВКонтакте',
    [constants.FIELD_DZEN]: 'Дзен',
};

export const initialParticipantModel = {
    [constants.PARTICIPANT_LASTNAME_RU]: '',
    [constants.PARTICIPANT_LASTNAME_EN]: '',
    [constants.PARTICIPANT_NAME_RU]: '',
    [constants.PARTICIPANT_NAME_EN]: '',
    [constants.PARTICIPANT_PATRONYMIC_RU]: '',
    [constants.PARTICIPANT_PATRONYMIC_EN]: '',
    [constants.PARTICIPANT_COMPANY_RU]: '',
    [constants.PARTICIPANT_COMPANY_EN]: '',
    [constants.PARTICIPANT_REGALIA_RU]:'',
    [constants.PARTICIPANT_REGALIA_EN]: '',
    [constants.PARTICIPANT_BIOGRAPHY_RU]: '',
    [constants.PARTICIPANT_BIOGRAPHY_EN]: '',
    [constants.PARTICIPANT_VK]: '',
    [constants.PARTICIPANT_TELEGRAM]: '',
    [constants.PARTICIPANT_DZEN]: '',
};

export const membersVisibility = [
    {
        value: false,
        label: 'Показать',
    },
    {
        value: true,
        label: 'Скрыть',
    },
];
